import React from "react";
import Footer from "../../components/modules/Footer";
import Navbar from "../../components/modules/Navbar";
import "./accesTournoiStyles.css";
import { BsFileArrowDown } from "react-icons/bs";
import { Link as LinkScroll } from "react-scroll";
import { useState } from "react";
import { useTranslation } from "react-i18next";

/* Import images */

import mapCS from "../../assets/plan/map_CS.png";
import mapEquitation from "../../assets/plan/map_equitation.png";
import mapX from "../../assets/plan/map_x.png";

const AccesTournoi = () => {
  const { t } = useTranslation("common");

  const [image, setImage] = useState(mapCS);
  const [nom, setNom] = useState("de CentraleSupélec");

  return (
    <div>
      <Navbar scroll="false" color="transparent" />
      <div className="acces-tournoi">
        <div className="acces-tournoi-home">
          <div className="acces-tournoi-title">
            <h1> {t("acces_tournoi.acces_tournoi")}</h1>
          </div>{" "}
          <LinkScroll to="plan" smooth={true} offset={-10} duration={1000}>
            {" "}
            <BsFileArrowDown
              style={{ color: "#ffffff" }}
              className="fleche-mazars"
            />
          </LinkScroll>
          <div className="vague">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffffff"
                fillOpacity="1"
                d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              ></path>
            </svg>
          </div>
        </div>

        <div className="acces-tournoi-plan" id="plan">
          <h2> Plan {nom}</h2>
          <div className="acces-tournoi-row">
            <div className="acces-tournoi-btn">
              <button
                onClick={() => {
                  setImage(mapCS);
                  setNom("Centrale Supélec");
                }}
              >
                {" "}
                de CentraleSupélec
              </button>
              <button
                onClick={() => {
                  setImage(mapX);
                  setNom("Polytechnique");
                }}
              >
                de Polytechnique
              </button>
              <button
                onClick={() => {
                  setImage(mapEquitation);
                  setNom("du centre équestre");
                }}
              >
                {" "}
                Centre équestre
              </button>
            </div>
            <div className="acces-tournoi-img">
              <img  src={image} alt="" />
            </div>
          </div>
        </div>
        <div className="acces-tournoi-how">
          <h2> {t("acces_tournoi.question1")}</h2>
          <div className="acces-tournoi-box">
            <div id="left-box">
              <h3> {t("acces_tournoi.venir")}</h3>
              <p> Ligne B - Direction St Remy les Chevreuses</p>
              <p> {t("acces_tournoi.arret")} - Le Guichet</p>
            </div>
            <div id="center-box">
              <h3>{t("acces_tournoi.voiture")}</h3>
              <p> {t("acces_tournoi.question2")}</p>
            </div>
            <div id="right-box">
              <h3> {t("acces_tournoi.train")}</h3>
              <p> {t("acces_tournoi.texte_train")}</p>
            </div>
          </div>
        </div>
        <div className="acces-tournoi-map">
          <h2> {t("acces_tournoi.plan2")}</h2>
          <iframe
            width="869"
            height="606"
            title="Plan d'accès CentraleSupélec"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            id="gmap_canvas"
            src="https://maps.google.com/maps?width=869&amp;height=606&amp;hl=en&amp;q=3%20rue%20Joliot%20Curie%20Gif%20Sur%20Yvette+(CentraleSup%C3%A9lec)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          ></iframe>
          <a href="https://maps-generator.com/">Maps Generator</a>
          <div className="acces-tournoi-data">
            <h5> Ecole CentraleSupélec</h5>
            <h5> 3 rue Joliot Curie</h5>
            <h5> 91190 | Gif-Sur-Yvette</h5>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AccesTournoi;
